<div class="d-flex align-items-center w-100 folder-item ps-2 mt-2" data-uit="ca-folder-item">
    <ca-icon name="folder" size="s" class="me-2"></ca-icon>
    <div class="flex-grow-1 me-2 overflow-hidden text-nowrap text-truncate">
        {{ name }}
        <small *ngIf="numberOfFiles != null">(<ca-number-of-files [numberOfFiles]="numberOfFiles"></ca-number-of-files>)</small>
    </div>
</div>
